import React, { ComponentProps, ComponentType } from "react";
import { Fab } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";

const withBackButton = (WrappedComponent: ComponentType<JSX.Element>) => {
  const WithBackButton = (props: ComponentProps<typeof WrappedComponent>) => {
    const history = useHistory();

    return (
      <>
        <Fab
          size="small"
          style={{
            position: "fixed",
            bottom: "2rem",
            right: "2rem",
            zIndex: 1,
          }}
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon />
        </Fab>
        <WrappedComponent {...props} />
      </>
    );
  };

  WithBackButton.displayName = `WithBackButton(${WrappedComponent.displayName ||
    WrappedComponent.name})`;
  return WithBackButton;
};

export default withBackButton;
